import { CALL_API, Schemas } from '../../common/middleware/api';

export const FRANCHISEES_REQUEST = 'FRANCHISEES_REQUEST';
export const FRANCHISEES_SUCCESS = 'FRANCHISEES_SUCCESS';
export const FRANCHISEES_FAILURE = 'FRANCHISEES_FAILURE';

export const FRANCHISEES_UNPAGED_REQUEST = 'FRANCHISEES_UNPAGED_REQUEST';
export const FRANCHISEES_UNPAGED_SUCCESS = 'FRANCHISEES_UNPAGED_SUCCESS';
export const FRANCHISEES_UNPAGED_FAILURE = 'FRANCHISEES_UNPAGED_FAILURE';

export const FRANCHISEE_FETCH_REQUEST = 'FRANCHISEE_GET_REQUEST';
export const FRANCHISEE_FETCH_SUCCESS = 'FRANCHISEE_GET_SUCCESS';
export const FRANCHISEE_FETCH_FAILURE = 'FRANCHISEE_GET_FAILURE';

export const FRANCHISEE_CREATE_REQUEST = 'FRANCHISEE_CREATE_REQUEST';
export const FRANCHISEE_CREATE_SUCCESS = 'FRANCHISEE_CREATE_SUCCESS';
export const FRANCHISEE_CREATE_FAILURE = 'FRANCHISEE_CREATE_FAILURE';

export const FRANCHISEE_UPDATE_REQUEST = 'FRANCHISEE_UPDATE_REQUEST';
export const FRANCHISEE_UPDATE_SUCCESS = 'FRANCHISEE_UPDATE_SUCCESS';
export const FRANCHISEE_UPDATE_FAILURE = 'FRANCHISEE_UPDATE_FAILURE';

export const loadFranchisees = (options) => ({
	[CALL_API]: {
		types: [FRANCHISEES_REQUEST, FRANCHISEES_SUCCESS, FRANCHISEES_FAILURE],
		endpoint: 'api/franchisees',
		request: options,
		schema: Schemas.FRANCHISEE_ARRAY
	}
});

export const loadUnpagedFranchisees = (options) => ({
	[CALL_API]: {
		types: [FRANCHISEES_UNPAGED_REQUEST, FRANCHISEES_UNPAGED_SUCCESS, FRANCHISEES_UNPAGED_FAILURE],
		endpoint: 'api/franchisees/unpaged',
		request: options,
		schema: Schemas.FRANCHISEE_ARRAY
	}
});

export const fetchFranchisee = (id) => ({
	[CALL_API]: {
		types: [FRANCHISEE_FETCH_REQUEST, FRANCHISEE_FETCH_SUCCESS, FRANCHISEE_FETCH_FAILURE],
		endpoint: `api/franchisees/${id}`,
		schema: Schemas.FRANCHISEE
	}
});

export const createFranchisee = (franchisee, history) => ({
	[CALL_API]: {
		types: [FRANCHISEE_CREATE_REQUEST, FRANCHISEE_CREATE_SUCCESS, FRANCHISEE_CREATE_FAILURE],
		endpoint: 'api/franchisees',
		method: 'POST',
		request: franchisee,
		schema: Schemas.FRANCHISEE,
		form: 'newFranchisee',
		transition: {
			history,
			successPath: (response) => {
				return `/franchisees/${response.result}`;
			}
		}
	}
});

export const updateFranchisee = (id, franchisee) => ({
	[CALL_API]: {
		types: [FRANCHISEE_UPDATE_REQUEST, FRANCHISEE_UPDATE_SUCCESS, FRANCHISEE_UPDATE_FAILURE],
		endpoint: `api/franchisees/${id}`,
		method: 'PUT',
		request: franchisee,
		schema: Schemas.FRANCHISEE,
		form: 'franchisee'
	}
});